export function SendIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M17.4472 11.3944C17.786 11.225 18 10.8788 18 10.5C18 10.1212 17.786 9.77498 17.4472 9.60558L3.44721 2.60558C3.09251 2.42823 2.66653 2.47724 2.36136 2.7305C2.0562 2.98376 1.92953 3.39342 2.03848 3.77473L3.46704 8.77472C3.5897 9.20402 3.98209 9.5 4.42857 9.5H9C9.55229 9.5 10 9.94772 10 10.5C10 11.0523 9.55229 11.5 9 11.5H4.42857C3.98209 11.5 3.58971 11.796 3.46705 12.2253L2.03848 17.2253C1.92953 17.6066 2.0562 18.0163 2.36136 18.2695C2.66653 18.5228 3.09251 18.5718 3.44721 18.3944L17.4472 11.3944Z'
        fill='currentColor'
      />
    </svg>
  )
}
